export const removeWhitespace = (value: string | undefined | null): string | undefined => {
    if (value === undefined || value === null) {
        return undefined;
    }

    return value.replace(/\s/g, "");
};
